export function formatAddress(address?: string | null) {
  if (!address) {
    return [];
  }
  return address
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
}

/**
 * Formats a phone number for display according to locale
 * Supports US/CA format: (123) 456-7890
 * Falls back to international format for other locales
 */
export function formatPhoneNumber(phone: string, locale?: string): string {
  const digits = phone.replace(/\D/g, "");
  const detectedLocale = locale || "en-US";

  // US/CA phone number formatting: (123) 456-7890
  if (detectedLocale.startsWith("en-US") || detectedLocale.startsWith("en-CA")) {
    if (digits.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    if (digits.length === 11 && digits.startsWith("1")) {
      return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }
  }

  // UK format: +44 20 1234 5678
  if (detectedLocale.startsWith("en-GB")) {
    if (digits.startsWith("44")) {
      const ukNumber = digits.slice(2);
      if (ukNumber.length === 10) {
        return `+44 ${ukNumber.slice(0, 2)} ${ukNumber.slice(2, 6)} ${ukNumber.slice(6)}`;
      }
    }
  }

  // International format with country code: +XX XXX XXX XXXX
  if (digits.length > 10) {
    const countryCode = digits.slice(0, -10);
    const number = digits.slice(-10);
    return `+${countryCode} ${number.slice(0, 3)} ${number.slice(3, 6)} ${number.slice(6)}`;
  }

  // 10-digit number without country code - format as US style
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  // Fallback: return original if we can't format it
  return phone;
}

/**
 * Creates a tel: link from a phone number
 * Strips formatting and keeps only digits and + for international numbers
 */
export function formatTel(phone?: string | null): string | undefined {
  if (!phone) {
    return undefined;
  }
  // Keep digits and + for international numbers
  const dial = phone.replace(/[^\d+]/g, "");
  return dial ? `tel:${dial}` : undefined;
}
